import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  firstRow: {
    display: 'grid',
    alignItems: 'center',
    gridTemplateColumns: '1fr 1fr 1fr 1.5fr 1fr',
    columnGap: 16,
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr'
    }
  },
  checkText: { fontWeight: 600, marginBottom: 4 },
  row: { display: 'flex', alignItems: 'center' },
  icon: {
    fontSize: 20,
    marginRight: 4,
    [theme.breakpoints.down('sm')]: {
      fontSize: 12
    }
  },
  boldText: { fontWeight: 600, fontSize: 18, marginRight: 4 },
  lightText: { fontWeight: 500, fontSize: 16 },
  datePicker: { marginRight: 16 },
  chipText: {
    fontSize: 16,
    fontWeight: 500,
    [theme.breakpoints.down('sm')]: {
      fontSize: 10
    }
  },
  paymentChip: {
    padding: 4,
    background: theme.palette.secondary.light,
    width: 'fit-content'
    // '& .MuiChip-label': {
    //   fontSize: 12,
    //   color: theme.palette.grey[600]
    // }
  },
  horizontal: { display: 'flex', gap: 8, alignItems: 'center' },
  btnText: { textDecoration: 'underline', fontSize: 16, fontWeight: 500 }
}))
export default useStyles
